import BundleItemProductCard from '../BundleItemProductCard';
import styles from './BundleItem.module.scss';
import { BundleItemProps } from './types';

const BundleItem = ({
  bundleItem,
  isPrimaryBundle,
  hidePrimaryDescription,
}: BundleItemProps) => (
  <div
    data-testid={`bundle-item-product-key-${bundleItem.product?.key}`}
    className={styles['bundle-item-container']}
  >
    <BundleItemProductCard
      bundleItem={bundleItem}
      isPrimaryItem={isPrimaryBundle}
      hidePrimaryDescription={hidePrimaryDescription}
    />
  </div>
);

export default BundleItem;
